import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import api from "../services/api";
import toastError from "../errors/toastError";

const PhoneVerificationGate = ({ user, onVerified }) => {
  const [code, setCode] = useState("");
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [confirming, setConfirming] = useState(false);
  const phone = String(user?.phone || "");

  const send = async () => {
    setSending(true);
    try {
      await api.post("/auth/phone/send");
      setSent(true);
    } catch (error) {
      toastError(error);
    } finally {
      setSending(false);
    }
  };

  const confirm = async (event) => {
    event.preventDefault();
    setConfirming(true);
    try {
      await api.post("/auth/phone/confirm", { code });
      onVerified();
    } catch (error) {
      toastError(error);
    } finally {
      setConfirming(false);
    }
  };

  return (
    <div style={{ maxWidth: 460, margin: "48px auto", padding: 24 }}>
      <Typography variant="h5" style={{ fontWeight: 800, marginBottom: 8 }}>
        Confirma tu WhatsApp
      </Typography>
      <Typography style={{ color: "#475569", marginBottom: 16, lineHeight: 1.5 }}>
        Te enviamos un código al {phone || "número que registraste"} para comprobar que es tuyo.
        Así evitamos cuentas repetidas.
      </Typography>
      {!sent ? (
        <Button variant="contained" color="primary" disabled={sending} onClick={send}>
          {sending ? "Enviando…" : "Enviar código"}
        </Button>
      ) : (
        <form onSubmit={confirm}>
          <TextField
            fullWidth
            variant="outlined"
            label="Código de 6 dígitos"
            value={code}
            onChange={(event) => setCode(event.target.value.replace(/\D/g, "").slice(0, 6))}
            inputProps={{ inputMode: "numeric", autoComplete: "one-time-code" }}
            style={{ marginBottom: 12 }}
          />
          <Button type="submit" variant="contained" color="primary" disabled={confirming || code.length < 6}>
            {confirming ? "Confirmando…" : "Confirmar número"}
          </Button>
          <Button type="button" disabled={sending} onClick={send} style={{ marginLeft: 8 }}>
            Reenviar
          </Button>
        </form>
      )}
    </div>
  );
};

export default PhoneVerificationGate;
